module.exports = __webpack_public_path__ + "static/media/share.9d89920b.svg";